import { separateCamelCase } from 'src/utils/text';
import makeStyles from '@mui/styles/makeStyles';

export const disabledColumns = ['createdDate', 'createdBy', 'id'];

export const convertToHeader = ({ table, id, type }) => {
  const base = {
    id,
    label: separateCamelCase(id).join(' '),
    key: `${table.name}-${id}`,
    disabled: disabledColumns.includes(id),
  };
  switch (type) {
    case 'DATE': {
      return {
        ...base,
        inputType: 'dateTime',
      };
    }
    case 'FOREIGN_KEY': {
      return {
        ...base,
        inputType: 'select',
        options: table.foreignColumns[id].map(({ id: optionId, name }) => ({
          label: `${name}`,
          value: optionId,
        })),
        optionLabel: 'label',
        optionValue: 'value',
        table: true,
      };
    }
    case 'INTEGER':
      return {
        ...base,
        inputType: 'text',
        type: 'number',
        step: 1,
      };
    case 'BOOLEAN': {
      return {
        ...base,
        inputType: 'checkbox',
      };
    }
    case 'TEXT': {
      return {
        ...base,
        inputType: 'text',
        multiline: true,
      };
    }
    default: {
      return {
        ...base,
        inputType: 'text',
        mask: ['mainPhone', 'labPhone'].includes(id) ? 'phone' : null,
      };
    }
  }
};

export const useStyles = makeStyles(() => ({
  cell: {
    margin: '0 0.5rem',
  },
}));

export const checkNoteTemplateDuplicates = ({ values }) => {
  const def = values.definitions.find((d) => d.name === 'NoteTemplate');
  if (def) {
    const seen = new Set();
    for (const row of def.rows) {
      const { name, active } = row;

      if (active) {
        if (seen.has(name)) {
          return true;
        } else {
          seen.add(name);
        }
      }
    }
  }
  return false;
};

const VALID_EMAIL_EXCEPTIONS = ['na', 'n/a'];

export const validateAuthContact = (contact) => {
  const errors = {};
  const email = contact?.email?.trim();

  if (email && !VALID_EMAIL_EXCEPTIONS.includes(email.toLowerCase())) {
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!isValidEmail) {
      errors.email = 'Invalid email address';
    }
  }

  if (Number(contact?.mainPhoneCountryCodeId) === 1) {
    const digits = String(contact?.mainPhone || '').replace(/\D/g, '');
    if (digits.length > 0 && digits.length !== 10) {
      errors.mainPhone = 'Phone number must be 10 digits';
    }
  }

  return errors;
};

export const validateAuthFormLocally = (values) => {
  const errors = {};

  ['authorizationContact', 'designeeContact', 'notifiedContact'].forEach(
    (key) => {
      const contactErrors = validateAuthContact(values?.[key]);
      if (Object.keys(contactErrors).length > 0) {
        errors[key] = contactErrors;
      }
    },
  );

  return errors;
};
